import { PropsWithChildren } from 'react';
import { css } from '@linaria/atomic';
import { AnimatePresence, motion, DragHandlers } from 'motion/react';
import { useSlideCarousel } from '../provider';

type SlidePanelProps = {
  id: string;
};

export const SlidePanel = ({ id, children }: PropsWithChildren<SlidePanelProps>) => {
  const { slideIds, activeId, setActiveId, canDrag, slideGap } = useSlideCarousel();
  const index = slideIds.indexOf(id);
  const activeIndex = slideIds.indexOf(activeId);
  const offset = index - activeIndex;
  const xOffset = `calc(${offset * 100}% + ${offset * slideGap}px)`;

  const handleDragEnd: DragHandlers['onDragEnd'] = (_event, info) => {
    const next = slideIds[activeIndex + 1];
    const prev = slideIds[activeIndex - 1];
    if (info.offset.x < -50 && activeIndex < slideIds.length - 1 && next) {
      setActiveId(next);
    } else if (info.offset.x > 50 && activeIndex > 0 && prev) {
      setActiveId(prev);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        id={id}
        className={slidePanelStyle}
        initial={{ x: xOffset }}
        animate={{ x: xOffset }}
        drag={canDrag ? 'x' : false}
        dragConstraints={{ left: 0, right: 0 }}
        onDragEnd={handleDragEnd}
        transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20,
          mass: 0.75,
          bounce: 0.25,
          ease: [0.43, 0.13, 0.23, 0.96],
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

const slidePanelStyle = css`
  position: absolute;
  height: 100%;
  width: 100%;
  min-width: 100%;
  left: 0;
  top: 0;
`;
